<template>
    <v-dialog v-model="show" width="1000px">
        <v-card style="padding: 24px">
            <v-card-title>Данные по объектам договора</v-card-title>
            <v-card-actions>
                <v-row v-if="!loading">
                    <v-expansion-panels flat accordion multiple>
                        <v-expansion-panel v-for="{ contract, details } of getObjectContracts" :key="contract.obj_contract_rid">
                            <v-divider></v-divider>
                            <v-expansion-panel-header>
                                <v-row>
                                    <v-col>
                                        {{ contract.obj_contract_number }}
                                    </v-col>
                                    <v-col>
                                        {{ contract.object_name }}
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row>
                                    <v-col>
                                        <div class="w-50 subtitle-1">Адрес</div>
                                    </v-col>
                                    <v-col class="mr-7">
                                        <div>{{ details.address_full_name }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div class="w-50 subtitle-1">Административный район</div>
                                    </v-col>
                                    <v-col class="mr-7">
                                        <div>{{ details.district_name }}</div>
                                        <div>{{ details.service_center_name }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div class="w-50 subtitle-1">Период обслуживания по договору с-по</div>
                                    </v-col>
                                    <v-col class="mr-7">
                                        <div>
                                            {{ servicePeriod(details) }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Наименование услуги
                                                </th>
                                                <th class="text-left">
                                                    Состояние
                                                </th>
                                                <th class="text-left">
                                                    Нагрузка по услуге
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="detail in details['object_servs']" :key="detail['serv_type_name']">
                                                <td>{{ detail['serv_type_name'] }}</td>
                                                <td>
                                                    <v-row :class="detail['connection_info'][0]['is_connected'] ? 'green--text' : 'red--text'">
                                                        {{ detail['connection_info'][0]['is_connected'] ? 'Подключено' : 'Отключено' }}
                                                    </v-row>
                                                    <v-row>
                                                        {{ detail['connection_info'][0]['action_date'] }}
                                                    </v-row>
                                                </td>
                                                <td>
                                                    <v-row>
                                                        {{ detail['load_info'][0]['obj_suppl_load_value'] }}
                                                    </v-row>
                                                    <v-row>
                                                        {{ detail['load_info'][0]['obj_suppl_load_date'] }}
                                                    </v-row>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-row justify="end">
                        <v-col cols="auto">
                            <v-btn @click.stop="show = false" rounded>Закрыть</v-btn>
                        </v-col>
                    </v-row>
                </v-row>
                <v-skeleton-loader width="950px" height="100px" v-else type="card" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ContractsService from '@/services/apiRequests/contracts.service';
import translate from '@/utils/translate.util';

export default {
    name: 'ObjectDetailsDialog',
    props: ['recordId', 'value'],
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        getObjectContracts() {
            return translate(this.object_contracts, 'full', this.$i18n.locale);
        }
    },
    data: function() {
        return {
            object_contracts: [],
            loading: false
        };
    },
    methods: {
        async getUserObjectContractsList() {
            this.loading = true;
            const response = await ContractsService.getUserObjectContractsList({ contract_rid: this.recordId });
            const objContracts = response.data['object_contracts'];

            this.object_contracts = await Promise.all(
                objContracts.map(async contract => {
                    const details = await ContractsService.getUserObjectContractsDetailList(contract.obj_contract_rid);
                    return { contract, details: details.data };
                })
            );

            //delay for loader
            setTimeout(() => {
                this.loading = false;
            }, 400);
        },
        servicePeriod(details) {
            return (
                details['object_periods']['date_obj_contract_begin'] +
                ' - ' +
                (details['object_periods']['date_obj_contract_end'] ? details['object_periods']['date_obj_contract_end'] : '')
            );
        }
    },
    watch: {
        recordId: {
            handler() {
                this.getUserObjectContractsList();
            }
        }
    }
};
</script>

<style></style>
